// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./app/assets/fonts/Lato-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./app/assets/fonts/Lato-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./app/assets/fonts/Cairo-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./app/assets/fonts/Cairo-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./app/assets/fonts/chirp.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./app/assets/fonts/chirp-bold-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./app/assets/fonts/chirp-heavy-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./app/assets/fonts/chirp-medium-web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./app/assets/fonts/chirp-regular-web.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: LatoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  font-display: swap;
}
@font-face {
  font-family: LatoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  font-display: swap;
}
@font-face {
  font-family: CairoRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  font-display: swap;
}
@font-face {
  font-family: CairoBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  font-display: swap;
}
@font-face {
  font-family: chirp;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  font-display: swap;
}
@font-face {
  font-family: chirpBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  font-display: swap;
}
@font-face {
  font-family: chirpHeavy;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  font-display: swap;
}
@font-face {
  font-family: chirpMedium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  font-display: swap;
}
@font-face {
  font-family: chirpRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  font-display: swap;
}
h2 {
  font-size: 18px;
  text-transform: uppercase;
  position: relative;
  margin-bottom: 40px;
}
body[dir=ltr] h2 {
  font-family: "LatoBold", "CairoBold", sans-serif !important;
}
body[dir=rtl] h2 {
  font-family: "CairoBold", "LatoBold", sans-serif !important;
}
h2::before {
  content: "";
  position: absolute;
  start: 0;
  bottom: -10px;
  border: 2px solid var(--secondaryColor);
  width: 42px;
  background-color: var(--secondaryColor);
}

.scroll::-webkit-scrollbar {
  height: 8px;
}
.scroll::-webkit-scrollbar-track {
  background-color: var(--bodyColor);
}
.scroll::-webkit-scrollbar-thumb {
  background-color: var(--mainColor);
}

* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
*::-webkit-scrollbar {
  display: none;
}

body {
  font-weight: 400;
  background-color: var(--bodyColor);
  color: var(--mainColor);
  overflow-x: hidden;
  font-size: 14px;
}
body[dir=ltr] {
  font-family: "LatoRegular", "CairoRegular", sans-serif;
}
body[dir=rtl] {
  font-family: "CairoRegular", "LatoRegular", sans-serif;
}
body::-webkit-scrollbar {
  display: none;
}
body > iframe[style="position: fixed; inset: 0px; width: 100vw; height: 100vh; border: none; z-index: 2147483647;"] {
  display: none;
}

a,
link,
a:link,
a:active {
  color: var(--mainColor);
  text-decoration: none;
}

.active {
  color: var(--secondaryColor);
}

.actionsCell {
  display: flex;
  flex-direction: column;
  width: 100%;
}

h3 {
  font-size: 14px !important;
  text-transform: uppercase;
}
body[dir=ltr] h3 {
  font-family: "LatoBold", "CairoBold", sans-serif !important;
}
body[dir=rtl] h3 {
  font-family: "CairoBold", "LatoBold", sans-serif !important;
}

h4 {
  font-size: 12px !important;
  text-transform: uppercase;
  margin-bottom: 10px;
}

p {
  font-size: 10px !important;
}

*::-webkit-scrollbar {
  width: 8px;
}

*::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px grey;
}

*::-webkit-scrollbar-thumb {
  background-color: var(--mainColor);
  outline: 1px solid slategrey;
}

.MuiButton-root {
  color: var(--mainColor) !important;
  border: 1px solid var(--borderColor) !important;
  width: 102px;
  height: 30px;
  text-transform: capitalize !important;
  border-radius: 0 !important;
}
.MuiButton-root[dir=ltr] {
  font-family: "LatoRegular", "CairoRegular", sans-serif !important;
}
.MuiButton-root[dir=rtl] {
  font-family: "CairoRegular", "LatoRegular", sans-serif !important;
}

.MuiFormControl-root {
  width: 100%;
}

.apexcharts-tooltip.apexcharts-theme-light {
  background-color: var(--bgColor) !important;
  border: 1px solid var(--borderColor) !important;
}

.main-btn {
  background-color: var(--secondaryColor) !important;
  color: var(--bgColor) !important;
  border: 0 !important;
}

button {
  font-size: 10px !important;
  font-family: "LatoRegular", "CairoRegular", sans-serif;
}

.deleteHolder {
  display: flex;
  justify-content: space-between;
}
.deleteHolder p {
  font-size: 12px !important;
  font-weight: bold;
}

.text-btn-holder {
  display: flex;
}

.text-btn {
  background-color: transparent;
  border: none;
  align-items: center;
  text-align: right;
  font-size: 12px !important;
  color: var(--secondaryColor);
  text-transform: capitalize;
  cursor: pointer;
}
body[dir=ltr] .text-btn {
  font-family: "LatoRegular", "CairoRegular", sans-serif !important;
}
body[dir=rtl] .text-btn {
  font-family: "CairoRegular", "LatoRegular", sans-serif !important;
}

.unstyled-button {
  background-color: "transparent";
  padding: none;
  border: none;
  height: 0;
  cursor: pointer;
}
.unstyled-button[data-error=true] path:first-of-type {
  stroke: var(--errorColor);
}
.unstyled-button[data-error=true] path:last-of-type {
  fill: var(--errorColor);
}
.unstyled-button:disabled, .unstyled-button [disabled] {
  cursor: inherit;
}

.phoneInputStyle {
  display: flex;
  margin-top: 10px;
  align-items: flex-end;
}
.phoneInputStyle div {
  width: 100%;
}
.phoneInputStyle button {
  margin-top: 1em;
}

.fullWidthWithBtn div {
  width: 95%;
}

.leaflet-container {
  height: 763px;
  width: 100%;
  z-index: 500;
}

.leaflet-control-container .leaflet-left,
leaflet-control-container .leaflet-top {
  right: 1rem;
  bottom: 1rem;
}

.leaflet-touch .leaflet-bar a {
  line-height: 19px !important;
  width: 23px !important;
  height: 23px !important;
  font-size: 19px;
  font-weight: 100;
  color: #555;
}

.leaflet-control-zoom {
  position: absolute !important;
  right: 0;
  bottom: 0;
}

.leaflet-control-zoom-in {
  margin-bottom: 1rem;
}

.leaflet-control-zoom-out {
  margin-bottom: 1rem;
}

.leaflet-control-zoom {
  border: none !important;
}

.leaflet-control-attribution {
  display: none;
}

.leaflet-control-zoom a {
  border: 1px solid !important;
}

.actionsCell:hover .actions {
  opacity: 1;
}

.actions {
  opacity: 0;
  z-index: 1;
}
@media (max-width: 992px) {
  .actions {
    opacity: 1;
  }
}

@media (max-width: 992px) {
  div[class*=PrivateSwitchBase] {
    padding: 0;
  }
}

.mr-5 {
  -webkit-margin-end: 5px;
          margin-inline-end: 5px;
}

.ml-5 {
  -webkit-margin-start: 5px;
          margin-inline-start: 5px;
}

.mb-20 {
  margin-bottom: 20px;
}

.mb-10 {
  margin-bottom: 10px;
}

.mb-15 {
  margin-bottom: 15px;
}

.mr-20 {
  -webkit-margin-end: 20px !important;
          margin-inline-end: 20px !important;
}

.mr-5 {
  -webkit-margin-end: 5px !important;
          margin-inline-end: 5px !important;
}

.mb-30 {
  margin-bottom: 30px;
}

.mt-10 {
  margin-top: 10px;
}

.mt-16 {
  margin-top: 16px;
}

.mt-30 {
  margin-top: 30px;
}

.mt-5 {
  margin-top: 5px;
}

.mt-20- {
  margin-top: -20px;
}

.m-auto {
  margin-left: auto;
  margin-right: auto;
}

.d-block {
  display: block;
}

body[dir=rtl] .mt-5-ar {
  margin-top: 5px;
}

.flex-alignCenter {
  display: flex;
  align-items: center;
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.flex-sb {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.flex-wrap {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.hide-last :last-child span {
  display: none;
}

.cursor-pointer {
  cursor: pointer;
}
.cursor-pointer-decoration {
  -webkit-text-decoration-line: underline;
          text-decoration-line: underline;
}

.p-20 {
  padding: 20px;
}

.p-line-20 {
  padding-inline: 20px !important;
}

.p-line-10 {
  padding-inline: 10px !important;
}

.p-30 {
  padding: 30px;
}

.p-lin-s {
  -webkit-padding-start: 20px;
          padding-inline-start: 20px;
}

.pb-20 {
  padding-bottom: 20px;
}

.b-1 {
  border: 1px solid var(--borderColor);
}

.bt-1 {
  border-top: 1px solid var(--borderColor);
}

.bb-1 {
  border-bottom: 1px solid var(--borderColor);
}

.position-relative {
  position: relative;
}

.default-height {
  min-height: 272px;
}

.PageTopBar {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.PageTopBar button {
  border: none;
  background: transparent;
  vertical-align: middle;
  cursor: pointer;
}
.PageTopBar .Controls {
  position: relative;
  z-index: 99;
  height: 27px;
  display: flex;
  align-items: center;
}
@media (max-width: 992px) {
  .PageTopBar .Controls {
    display: flex;
    align-items: center;
  }
}

.Controls {
  height: 27px;
  display: flex;
  align-items: center;
}
@media (max-width: 992px) {
  .Controls {
    display: flex;
    align-items: center;
  }
}

.TopBar {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.TopBar .Controls {
  display: flex;
  align-items: center;
  align-self: baseline;
}
.TopBar .Controls > *:not(:last-child) {
  position: relative;
  padding: 0;
}
@media (max-width: 992px) {
  .TopBar .Controls > *:not(:last-child) {
    -webkit-margin-end: 20px;
            margin-inline-end: 20px;
  }
}
.TopBar .Controls > *:not(:last-child)::after {
  content: "";
  position: absolute;
  width: 2px;
  height: 20px;
  background-color: var(--borderColor);
}
body[dir=ltr] .TopBar .Controls > *:not(:last-child)::after {
  right: -20px;
}
body[dir=rtl] .TopBar .Controls > *:not(:last-child)::after {
  left: -20px;
}
@media (max-width: 992px) {
  body[dir=ltr] .TopBar .Controls > *:not(:last-child)::after {
    right: -10px;
  }
  body[dir=rtl] .TopBar .Controls > *:not(:last-child)::after {
    left: -10px;
  }
}

.gap-5 *:not(:last-child) {
  margin-bottom: 5px;
}

.Controls > * {
  padding: 0 !important;
  color: var(--borderColor);
}
.Controls > *:not(:first-of-type) {
  -webkit-margin-start: 20px;
          margin-inline-start: 20px;
}
.Controls > *:not(:last-of-type) {
  position: relative;
  -webkit-margin-end: 10px;
          margin-inline-end: 10px;
}
.Controls > *:not(:last-of-type)::after {
  content: "";
  position: absolute;
  width: 2px;
  height: 15px;
  background-color: var(--borderColor);
}
body[dir=ltr] .Controls > *:not(:last-of-type)::after {
  right: -20px;
}
body[dir=rtl] .Controls > *:not(:last-of-type)::after {
  left: -20px;
}

.MuiSvgIcon-root {
  margin: 0;
}

body[dir=ltr] input,
body[dir=ltr] textarea {
  font-family: "LatoRegular", "CairoRegular", sans-serif;
}
body[dir=rtl] input,
body[dir=rtl] textarea {
  font-family: "CairoRegular", "LatoRegular", sans-serif;
}

input::placeholder,
textarea::placeholder,
.select-input__placeholder {
  color: var(--mainColor) !important;
  text-transform: capitalize;
}

.MuiPaper-elevation1 {
  box-shadow: none !important;
}

.SaveCancel {
  display: flex;
  justify-content: space-around;
}
.SaveCancel button {
  cursor: pointer;
  display: inline-block;
  min-width: 102px;
  font-size: 10px;
  color: var(--mainColor);
  border: 1px solid #d7d7d7;
  padding: 9px 8px;
  transition: 0.3s ease-out;
  text-align: center;
  text-transform: uppercase;
}
.SaveCancel button:hover {
  color: var(--bgColor);
  border-color: var(--secondaryColor);
  background-color: var(--secondaryColor);
}

.InputHolder {
  padding: 20px;
  min-width: 100%;
  background-color: var(--bgColor);
}

.Toastify__toast-container {
  width: 365px;
  text-align: center;
  text-transform: capitalize;
  padding: 0;
  font-size: 12px !important;
}
body[dir=ltr] .Toastify__toast-container {
  font-family: "LatoRegular", "CairoRegular", sans-serif !important;
}
body[dir=rtl] .Toastify__toast-container {
  font-family: "CairoRegular", "LatoRegular", sans-serif !important;
}

.Toastify__toast {
  border-radius: 0;
  height: 30px;
  min-height: auto;
  margin-bottom: 0;
  padding: 0;
}

.Toastify__toast-body {
  padding: 0 8px;
}

.Toastify__toast--success {
  background-color: #ecedd8;
  border: 1px solid #9ea641;
  color: black;
}

.Toastify__toast--error {
  background-color: rgba(255, 28, 0, 0.5);
  border: 1px solid #ff1c00;
  color: black;
}

.errorColor {
  color: #ff1c00;
}

.Toastify__toast-container--top-center {
  top: 50px;
}

.MuiPickersDay-day.MuiPickersDay-dayDisabled {
  pointer-events: auto !important;
  cursor: not-allowed !important;
  background-color: var(--disabledDatePicker) !important;
}

body[dir=ltr] .MuiMenuItem-root,
body[dir=ltr] .MuiSelect-select.MuiSelect-select {
  font-family: "LatoRegular", "CairoRegular", sans-serif !important;
}
body[dir=rtl] .MuiMenuItem-root,
body[dir=rtl] .MuiSelect-select.MuiSelect-select {
  font-family: "CairoRegular", "LatoRegular", sans-serif !important;
}

.apexcharts-legend-text {
  word-break: break-all;
  text-align: center;
  align-items: center;
  padding-left: 0px !important;
  margin-left: 0px !important;
}

body[dir=ltr] .apexcharts-text {
  font-family: "LatoRegular", "CairoRegular", sans-serif !important;
}
body[dir=rtl] .apexcharts-text {
  font-family: "CairoRegular", "LatoRegular", sans-serif !important;
}
.apexcharts-text tspan {
  fill: var(--mainColor);
  font-size: 10px !important;
}

body[dir=rtl] .apexcharts-xaxis-texts-g {
  transform: translateY(10px);
}

.MuiTypography-caption,
.MuiPaginationItem-root {
  color: var(--mainColor) !important;
}
body[dir=ltr] .MuiTypography-caption,
body[dir=ltr] .MuiPaginationItem-root {
  font-family: "LatoRegular", "CairoRegular", sans-serif !important;
}
body[dir=rtl] .MuiTypography-caption,
body[dir=rtl] .MuiPaginationItem-root {
  font-family: "CairoRegular", "LatoRegular", sans-serif !important;
}

.MuiTypography-subtitle1 {
  font-size: 14px !important;
}
body[dir=ltr] .MuiTypography-subtitle1 {
  font-family: "LatoBold", "CairoBold", sans-serif !important;
}
body[dir=rtl] .MuiTypography-subtitle1 {
  font-family: "CairoBold", "LatoBold", sans-serif !important;
}

.apexcharts-data-labels text {
  fill: var(--mainColor);
  font-weight: 500;
  filter: none;
  line-height: 29;
}
body[dir=ltr] .apexcharts-data-labels text {
  font-family: "LatoRegular", "CairoRegular", sans-serif !important;
}
body[dir=rtl] .apexcharts-data-labels text {
  font-family: "CairoRegular", "LatoRegular", sans-serif !important;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.tableRow {
  line-height: 14px;
}

.secondaryTableRow a {
  width: -webkit-max-content !important;
  width: max-content !important;
}

.default__link {
  padding: 0 4px;
  text-decoration: underline;
  color: var(--secondaryColor);
}
.default__link-gray {
  color: var(--mainColor);
  text-decoration: underline !important;
}
.default__link a {
  color: var(--secondaryColor);
  text-decoration: underline !important;
}

.button-link {
  font-family: inherit;
  background-color: transparent;
  background-color: initial;
  border: medium none currentColor;
  border: initial;
  transition: 0.2s;
  font-size: inherit;
  color: var(--mainColor);
}
.button-link:hover {
  color: var(--secondaryColor);
  text-decoration: underline !important;
}

.change_profile_img {
  margin: 30px 0;
  width: 102px;
  height: 102px;
  border-radius: 50%;
  margin-bottom: 30px;
  -webkit-margin-end: auto;
          margin-inline-end: auto;
  position: relative;
  cursor: pointer;
}
.change_profile_img svg {
  width: 100%;
  height: 100%;
}
.change_profile_img .img_holder {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  overflow: hidden;
  border: 1px solid var(--borderColor);
}
.change_profile_img .img_holder img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.change_profile_img label {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  border-radius: 100%;
  transition: 0.3s;
  cursor: pointer;
}
.change_profile_img label input[type=file] {
  display: none;
}

.dimmedHolder {
  position: relative;
}
.dimmedHolder .dimmed {
  position: absolute;
  left: 0;
  top: 26px;
  width: 100%;
  height: 54%;
  z-index: 2;
  background-color: var(--borderColor);
  opacity: 0.7;
}
.dimmedHolder .horizDimmed {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  background-color: var(--borderColor);
  opacity: 0.7;
}

.MuiDialog-container {
  background-color: var(--errorBoundBgColor);
}

.loader-holder {
  height: 500px;
  width: 100%;
  position: relative;
}

.source-input {
  display: flex;
  align-items: flex-end;
}
.source-input button {
  background-color: transparent;
  border: none;
  padding: 0px 10px 5px;
  cursor: pointer;
}
.source-input > div {
  width: 100%;
}

.source-link {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: block;
  margin-top: 10px;
}

.truncate-text {
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  font-family: inherit !important;
}

.trim-text {
  word-wrap: break-word;
  white-space: nowrap;
  width: 100%;
  overflow: hidden;
  display: block;
  text-overflow: ellipsis;
}

.MuiCheckbox-colorSecondary.Mui-checked {
  color: var(--mainColor) !important;
}

.InovuaReactDataGrid__row-cell-wrap:focus {
  outline: 0;
}

.InovuaReactDataGrid__cell--show-border-bottom,
.InovuaReactDataGrid--theme-default-light .InovuaReactDataGrid__header {
  border-bottom: 1px solid var(--borderColor) !important;
}

.flex-center-between {
  display: flex;
  justify-items: center;
  justify-content: space-between;
}

.pagination {
  padding-top: 30px;
  direction: ltr;
  direction: initial;
  display: flex;
  justify-content: center;
  align-items: center;
  /* height: 130px; */
}

.MuiTooltip-popper {
  z-index: 1000 !important;
}

.TopBar {
  display: flex;
  justify-content: space-between;
}

.loader-parent {
  position: relative;
  width: 100%;
  height: 85vh;
}

.apexcharts-tooltip-marker {
  -webkit-margin-end: 10px;
          margin-inline-end: 10px;
}

#videos-compareVideos-CompareInputsRow + div .apexcharts-yaxis .apexcharts-yaxis-texts-g {
  transform: translateY(-15px);
}

#mainFilter .select-input__input-container {
  padding: 1px 0px !important;
}

.apexcharts-tooltip {
  z-index: 9999 !important;
}

* .small_tooltip .apexcharts-tooltip {
  width: 150px !important;
  height: -webkit-max-content;
  height: max-content;
}
* .small_tooltip .apexcharts-tooltip .trending_topics {
  margin: 0 10px;
}
* .small_tooltip .apexcharts-tooltip .trending_topics :first-child {
  margin-bottom: 5px;
}
* .small_tooltip .apexcharts-tooltip .trending_topics * {
  font-size: 10px;
  font-family: "LatoRegular";
}

.w-10 {
  width: 10%;
}
.w-20 {
  width: 20%;
}
.w-30 {
  width: 30%;
}
.w-40 {
  width: 40%;
}
.w-50 {
  width: 50%;
}
.w-60 {
  width: 60%;
}
.w-70 {
  width: 70%;
}
.w-80 {
  width: 80%;
}
.w-90 {
  width: 90%;
}
.w-full {
  width: 100%;
}

.d-flex {
  display: flex;
}
.d-flex-between {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.d-flex-items-center {
  display: flex;
  align-items: center;
}
.d-flex-content-center {
  display: flex;
  justify-content: center;
}
.d-flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.pt-7 {
  padding-top: 7px;
}
.pt-10 {
  padding-top: 20px;
}
.pt-14 {
  padding-top: 14px;
}

.reactEasyCrop_Container {
  z-index: 111111;
}

.server-error {
  position: relative;
}
.server-error::before {
  content: attr(data-error-massage);
  display: block;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, 40px);
  z-index: 1248;
  color: var(--mainColor);
  font-weight: bold;
  font-size: 24px;
  text-align: center;
  text-transform: capitalize;
  background: var(--errorBoundBgColor);
  width: calc(100% - 40px);
  height: calc(100% - 40px);
  display: flex;
  align-items: center;
  justify-content: center;
}

textarea,
input,
pre,
.css-qc6sy-singleValue,
.css-12jo7m5,
.MuiTableCell-body,
.MuiTableCell-head,
.apexcharts-legend-text,
.MuiPaper-root,
.css-26l3qy-menu {
  color: var(--mainColor) !important;
  background-color: var(--bgColor);
}

.MuiMenu-paper {
  background-color: var(--bgColor) !important;
  border: 1px solid var(--borderColor) !important;
}

.notifications {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-weight: bold;
  text-transform: uppercase;
}
.notifications .notificatiosUserName {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  font-weight: normal;
  font-size: 12px;
  text-transform: capitalize;
}
.notifications .notifications-flex {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
}
.notifications .notifications-b > b {
  font-family: "CairoBold";
}

.apexcharts-text,
.MuiSvgIcon-root {
  fill: var(--mainColor) !important;
}

.link-without-hover:hover {
  color: inherit !important;
}

.custLoader {
  position: absolute;
  z-index: 11351;
  left: 50%;
  top: 45%;
  border: 5px solid #f3f3f3;
  animation: spin 1s linear infinite;
  border-top: 5px solid #555;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  overflow: hidden;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.custLoaderBg {
  background-color: var(--bgColor);
  z-index: 11350;
  top: 0;
  position: absolute;
  width: 100vw;
  height: 100%;
  overflow: hidden;
}

.custLoaderText {
  z-index: 11351;
  position: absolute;
  width: 100vw;
  text-align: center;
  top: 55%;
  font-size: 20px !important;
  font-family: "CairoBold";
  -webkit-padding-end: 40px;
          padding-inline-end: 40px;
  overflow: hidden;
  background-color: var(--bgColor);
}
body[dir=ltr] .custLoaderText {
  -webkit-padding-end: 0;
          padding-inline-end: 0;
  -webkit-padding-start: 40px;
          padding-inline-start: 40px;
}

.hide {
  overflow: hidden;
  background-color: var(--bgColor);
}

.MuiDialog-paper {
  overflow-y: visible !important;
}

.flex-center-gap-10 {
  display: flex;
  align-items: center;
  gap: 10px;
}

.flex-center-gap-5 {
  display: flex;
  align-items: center;
  gap: 5px;
}

.flex-center-gap-30 {
  display: flex;
  align-items: center;
  gap: 30px;
}

.flex-icons {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: wrap;
  column-gap: 7px;
}
.flex-icons svg {
  width: 18px;
}

.flex-column-reverse {
  display: flex;
  justify-content: center;
  flex-direction: column-reverse;
  gap: 5px;
  width: auto !important;
  width: initial !important;
  -webkit-margin-end: 20px;
          margin-inline-end: 20px;
}

.tweetSubTitleColor {
  color: var(--tweetSubTitleColor) !important;
}

.instagramColor {
  color: var(--instagramColor) !important;
}

.labelDisabled {
  color: var(--disabledLabel) !important;
}

.apexcharts-tooltip-title {
  background-color: var(--bodyColor) !important;
  border-bottom: 1px solid var(--borderColor) !important;
}

body.no-Events {
  pointer-events: none !important;
}

.descriptionContent {
  max-width: 100%;
}

.MuiSwitch-thumb {
  position: absolute;
  top: 10px;
  left: 0;
}

.Mui-checked .MuiSwitch-thumb {
  left: 10px;
  background-color: var(--secondaryColor);
}
.Mui-checked .MuiSwitch-track {
  background-color: var(--secondaryColor);
}

.MuiIconButton-root {
  padding: 5px !important;
}

.Active {
  color: var(--positiveColor);
}

.Suspended {
  color: var(--negativeColor);
}

.text-center {
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/app/assets/scss/vars.scss","webpack://./src/index.scss"],"names":[],"mappings":"AAKA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACJF;ADOA;EACE,qBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADOA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACLF;ADQA;EACE,kBAAA;EACA,4CAAA;EACA,kBAAA;ACNF;ADSA;EACE,sBAAA;EACA,4CAAA;EACA,kBAAA;ACPF;ADUA;EACE,uBAAA;EACA,4CAAA;EACA,kBAAA;ACRF;ADWA;EACE,wBAAA;EACA,4CAAA;EACA,kBAAA;ACTF;ADYA;EACE,yBAAA;EACA,4CAAA;EACA,kBAAA;ACVF;ADyBA;EAOE,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AC7BF;ADoBE;EACE,2DAAA;AClBJ;ADoBE;EACE,2DAAA;AClBJ;ADyBE;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,aAAA;EACA,uCAAA;EACA,WAAA;EACA,uCAAA;ACvBJ;;ADsGE;EACE,WAAA;ACnGJ;ADsGE;EACE,kCAAA;ACpGJ;ADuGE;EACE,kCAAA;ACrGJ;;AAzEA;EACE,UAAA;EACA,SAAA;EACA,sBAAA;AA4EF;AA3EE;EACE,aAAA;AA6EJ;;AA1EA;EAcE,gBAAA;EACA,kCAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;AAgEF;AAjFE;EACE,sDD6CU;ACsCd;AAjFE;EACE,sDD4CW;ACuCf;AAjFE;EACE,aAAA;AAmFJ;AAjFE;EAEE,aAAA;AAkFJ;;AA1EA;;;;EAIE,uBAAA;EACA,qBAAA;AA6EF;;AA3EA;EACE,4BAAA;AA8EF;;AA5EA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AA+EF;;AArEA;EDyDI,0BAAA;ECvDF,yBAAA;AAwEF;ADhBI;EACE,2DAAA;ACkBN;ADhBI;EACE,2DAAA;ACkBN;;AA1EA;EDiDI,0BAAA;EC/CF,yBAAA;EACA,mBAAA;AA6EF;;AA1EA;EDyCI,0BAAA;ACqCJ;;AA1EA;EACE,UAAA;AA6EF;;AA1EA;EACE,8BAAA;AA6EF;;AA1EA;EACE,kCAAA;EACA,4BAAA;AA6EF;;AA1EA;EACE,kCAAA;EACA,+CAAA;EACA,YAAA;EACA,YAAA;EACA,qCAAA;EACA,2BAAA;AA6EF;AA5EE;EACE,iEAAA;AA8EJ;AA5EE;EACE,iEAAA;AA8EJ;;AA3EA;EACE,WAAA;AA8EF;;AA5EA;EACE,2CAAA;EACA,+CAAA;AA+EF;;AA7EA;EACE,kDAAA;EACA,gCAAA;EACA,oBAAA;AAgFF;;AA9EA;EDFI,0BAAA;ECIF,sDDrDY;ACsId;;AA/EA;EACE,aAAA;EACA,8BAAA;AAkFF;AAjFE;EDPE,0BAAA;ECSA,iBAAA;AAmFJ;;AAhFA;EACE,aAAA;AAmFF;;AAhFA;EACE,6BAAA;EACA,YAAA;EACA,mBAAA;EAEA,iBAAA;EDrBE,0BAAA;ECuBF,4BAAA;EACA,0BAAA;EACA,eAAA;AAkFF;AAjFE;EACE,iEAAA;AAmFJ;AAjFE;EACE,iEAAA;AAmFJ;;AAhFA;EACE,+BAAA;EACA,aAAA;EACA,YAAA;EACA,SAAA;EACA,eAAA;AAmFF;AAlFE;EACE,yBAAA;AAoFJ;AAlFE;EACE,uBAAA;AAoFJ;AAlFE;EAEE,eAAA;AAmFJ;;AAhFA;EACE,aAAA;EACA,gBAAA;EACA,qBAAA;AAmFF;AAlFE;EACE,WAAA;AAoFJ;AAlFE;EACE,eAAA;AAoFJ;;AAhFE;EACE,UAAA;AAmFJ;;AAhFA;EACE,aAAA;EACA,WAAA;EACA,YAAA;AAmFF;;AAjFA;;EAEE,WAAA;EACA,YAAA;AAoFF;;AAlFA;EACE,4BAAA;EACA,sBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAqFF;;AAnFA;EACE,6BAAA;EACA,QAAA;EACA,SAAA;AAsFF;;AApFA;EACE,mBAAA;AAuFF;;AArFA;EACE,mBAAA;AAwFF;;AAtFA;EACE,uBAAA;AAyFF;;AAvFA;EACE,aAAA;AA0FF;;AAxFA;EACE,4BAAA;AA2FF;;AAxFA;EACE,UAAA;AA2FF;;AAxFA;EACE,UAAA;EACA,UAAA;AA2FF;AD3JE;EC8DF;IAKI,UAAA;EA4FF;AACF;;ADhKE;ECuEF;IAEI,UAAA;EA4FF;AACF;;AAzFA;EACE,uBAAA;UAAA,sBAAA;AA4FF;;AA1FA;EACE,yBAAA;UAAA,wBAAA;AA6FF;;AA3FA;EACE,mBAAA;AA8FF;;AA5FA;EACE,mBAAA;AA+FF;;AA7FA;EACE,mBAAA;AAgGF;;AA9FA;EACE,mCAAA;UAAA,kCAAA;AAiGF;;AA/FA;EACE,kCAAA;UAAA,iCAAA;AAkGF;;AA/FA;EACE,mBAAA;AAkGF;;AAhGA;EACE,gBAAA;AAmGF;;AAjGA;EACE,gBAAA;AAoGF;;AAlGA;EACE,gBAAA;AAqGF;;AAnGA;EACE,eAAA;AAsGF;;AApGA;EACE,iBAAA;AAuGF;;AArGA;EACE,iBAAA;EACA,kBAAA;AAwGF;;AAtGA;EACE,cAAA;AAyGF;;AAtGE;EACE,eAAA;AAyGJ;;AAtGA;EACE,aAAA;EACA,mBAAA;AAyGF;;AAvGA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AA0GF;;AAxGA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AA2GF;;AAzGA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;AA4GF;;AAxGI;EACE,aAAA;AA2GN;;AAtGA;EACE,eAAA;AAyGF;AAxGE;EACE,uCAAA;UAAA,+BAAA;AA0GJ;;AAvGA;EACE,aAAA;AA0GF;;AAxGA;EACE,+BAAA;AA2GF;;AAzGA;EACE,+BAAA;AA4GF;;AA1GA;EACE,aAAA;AA6GF;;AA3GA;EACE,2BAAA;UAAA,0BAAA;AA8GF;;AA5GA;EACE,oBAAA;AA+GF;;AA5GA;EACE,oCAAA;AA+GF;;AA7GA;EACE,wCAAA;AAgHF;;AA9GA;EACE,2CAAA;AAiHF;;AA/GA;EACE,kBAAA;AAkHF;;AAhHA;EACE,iBAAA;AAmHF;;AAhHA;EACE,aAAA;EACA,8BAAA;EACA,WAAA;AAmHF;AAjHE;EACE,YAAA;EACA,uBAAA;EACA,sBAAA;EACA,eAAA;AAmHJ;AAjHE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;AAmHJ;ADzUE;ECiNA;IAOI,aAAA;IACA,mBAAA;EAqHJ;AACF;;AAlHA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;AAqHF;ADrVE;EC6NF;IAKI,aAAA;IACA,mBAAA;EAuHF;AACF;;AArHA;EACE,aAAA;EACA,8BAAA;EACA,WAAA;AAwHF;AAvHE;EAEE,aAAA;EACA,mBAAA;EACA,oBAAA;AAwHJ;AAtHE;EAEE,kBAAA;EACA,UAAA;AAuHJ;AD1WE;ECgPA;IAKI,wBAAA;YAAA,uBAAA;EAyHJ;AACF;AAxHI;EACE,WAAA;EACA,kBAAA;EAOA,UAAA;EACA,YAAA;EACA,oCAAA;AAoHN;AA5HM;EACE,YAAA;AA8HR;AA5HM;EACE,WAAA;AA8HR;AD5XE;ECoQM;IACE,YAAA;EA2HR;EAzHM;IACE,WAAA;EA2HR;AACF;;AAxGE;EACE,kBAAA;AA2GJ;;AAxGA;EACE,qBAAA;EACA,yBAAA;AA2GF;AA1GE;EACE,0BAAA;UAAA,yBAAA;AA4GJ;AA1GE;EACE,kBAAA;EACA,wBAAA;UAAA,uBAAA;AA4GJ;AA3GI;EACE,WAAA;EACA,kBAAA;EAOA,UAAA;EACA,YAAA;EACA,oCAAA;AAuGN;AA/GM;EACE,YAAA;AAiHR;AA/GM;EACE,WAAA;AAiHR;;AAzGA;EACE,SAAA;AA4GF;;AAxGE;;EACE,sDDhaU;AC4gBd;AA1GE;;EACE,sDDjaW;AC8gBf;;AA1GA;;;EAGE,kCAAA;EACA,0BAAA;AA6GF;;AA3GA;EACE,2BAAA;AA8GF;;AA5GA;EACE,aAAA;EACA,6BAAA;AA+GF;AA9GE;EACE,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,yBAAA;EACA,gBAAA;EAEA,yBAAA;EACA,kBAAA;EACA,yBAAA;AAgHJ;AA/GI;EACE,qBAAA;EACA,mCAAA;EACA,uCAAA;AAiHN;;AA7GA;EACE,aAAA;EACA,eAAA;EACA,gCAAA;AAgHF;;AA5GA;EACE,YAAA;EACA,kBAAA;EACA,0BAAA;EACA,UAAA;ED7ZE,0BAAA;AC6gBJ;AA9GE;EACE,iEAAA;AAgHJ;AA9GE;EACE,iEAAA;AAgHJ;;AA7GA;EACE,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,UAAA;AAgHF;;AA9GA;EACE,cAAA;AAiHF;;AA9GA;EACE,yBAAA;EACA,yBAAA;EACA,YAAA;AAiHF;;AA9GA;EACE,uCAAA;EACA,yBAAA;EACA,YAAA;AAiHF;;AA/GA;EACE,cAAA;AAkHF;;AAhHA;EACE,SAAA;AAmHF;;AAjHA;EACE,+BAAA;EACA,8BAAA;EACA,sDAAA;AAoHF;;AA7GE;;EACE,iEAAA;AAiHJ;AA/GE;;EACE,iEAAA;AAkHJ;;AA/GA;EACE,qBAAA;EAEA,kBAAA;EACA,mBAAA;EACA,4BAAA;EACA,2BAAA;AAiHF;;AA9GE;EACE,iEAAA;AAiHJ;AA/GE;EACE,iEAAA;AAiHJ;AA/GE;EACE,sBAAA;EDreA,0BAAA;ACulBJ;;AA7GE;EACE,2BAAA;AAgHJ;;AA5GA;;EAEE,kCAAA;AA+GF;AA9GE;;EACE,iEAAA;AAiHJ;AA/GE;;EACE,iEAAA;AAkHJ;;AA/GA;EDrfI,0BAAA;ACwmBJ;ADvmBI;EACE,2DAAA;ACymBN;ADvmBI;EACE,2DAAA;ACymBN;;AArHE;EAOE,sBAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;AAkHJ;AA3HI;EACE,iEAAA;AA6HN;AA3HI;EACE,iEAAA;AA6HN;;AApHA,gCAAA;AACA;;EAEE,wBAAA;EACA,SAAA;AAuHF;;AApHA,YAAA;AACA;EACE,0BAAA;AAuHF;;AArHA;EACE,iBAAA;AAwHF;;AArHE;EACE,qCAAA;EAAA,6BAAA;AAwHJ;;AArHA;EACE,cAAA;EACA,0BAAA;EACA,4BAAA;AAwHF;AAvHE;EACE,uBAAA;EACA,qCAAA;AAyHJ;AAvHE;EACE,4BAAA;EACA,qCAAA;AAyHJ;;AArHA;EACE,oBAAA;EACA,6BAAA;EAAA,yBAAA;EACA,gCAAA;EAAA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;AAwHF;AAvHE;EACE,4BAAA;EACA,qCAAA;AAyHJ;;AAtHA;EACE,cAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;UAAA,uBAAA;EACA,kBAAA;EACA,eAAA;AAyHF;AAxHE;EACE,WAAA;EACA,YAAA;AA0HJ;AAxHE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,oCAAA;AA0HJ;AAxHI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AA0HN;AAvHE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AAyHJ;AAvHI;EACE,aAAA;AAyHN;;AApHA;EACE,kBAAA;AAuHF;AAtHE;EACE,kBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,oCAAA;EACA,YAAA;AAwHJ;AAtHE;EACE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,oCAAA;EACA,YAAA;AAwHJ;;AArHA;EACE,0CAAA;AAwHF;;AAtHA;EACE,aAAA;EACA,WAAA;EACA,kBAAA;AAyHF;;AAvHA;EACE,aAAA;EACA,qBAAA;AA0HF;AAzHE;EACE,6BAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;AA2HJ;AAzHE;EACE,WAAA;AA2HJ;;AAvHA;EACE,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;AA0HF;;AAxHA;EACE,WAAA;EACA,uBAAA;EACA,gBAAA;EACA,+BAAA;AA2HF;;AAxHA;EACE,qBAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,uBAAA;AA2HF;;AAzHA;EACE,kCAAA;AA4HF;;AA1HA;EACE,UAAA;AA6HF;;AA3HA;;EAEE,sDAAA;AA8HF;;AA5HA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;AA+HF;;AA7HA;EACE,iBAAA;EACA,cAAA;EAAA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AAgIF;;AA7HA;EACE,wBAAA;AAgIF;;AA9HA;EACE,aAAA;EACA,8BAAA;AAiIF;;AA/HA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AAkIF;;AA/HA;EACE,wBAAA;UAAA,uBAAA;AAkIF;;AA/HA;EAIE,4BAAA;AA+HF;;AA5HA;EACE,2BAAA;AA+HF;;AA5HA;EACE,wBAAA;AA+HF;;AA1HI;EACE,uBAAA;EACA,2BAAA;EAAA,mBAAA;AA6HN;AA5HM;EACE,cAAA;AA8HR;AA7HQ;EACE,kBAAA;AA+HV;AA7HQ;EACE,eAAA;EACA,0BAAA;AA+HV;;AAtHE;EACE,UAAA;AAyHJ;AAvHE;EACE,UAAA;AAyHJ;AAvHE;EACE,UAAA;AAyHJ;AAvHE;EACE,UAAA;AAyHJ;AAvHE;EACE,UAAA;AAyHJ;AAvHE;EACE,UAAA;AAyHJ;AAvHE;EACE,UAAA;AAyHJ;AAvHE;EACE,UAAA;AAyHJ;AAvHE;EACE,UAAA;AAyHJ;AAvHE;EACE,WAAA;AAyHJ;;AArHE;EACE,aAAA;AAwHJ;AAvHI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAyHN;AAtHM;EACE,aAAA;EACA,mBAAA;AAwHR;AApHM;EACE,aAAA;EACA,uBAAA;AAsHR;AAnHI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AAqHN;;AA/GE;EACE,gBAAA;AAkHJ;AAhHE;EACE,iBAAA;AAkHJ;AAhHE;EACE,iBAAA;AAkHJ;;AA/GA;EACE,eAAA;AAkHF;;AAhHA;EACE,kBAAA;AAmHF;AAlHE;EACE,iCAAA;EACA,cAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,gCAAA;EACA,aAAA;EACA,uBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,0BAAA;EACA,oCAAA;EACA,wBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAoHJ;;AAhHA;;;;;;;;;;EAUE,kCAAA;EACA,gCAAA;AAmHF;;AAjHA;EACE,2CAAA;EACA,+CAAA;AAoHF;;AAlHA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;AAqHF;AAnHE;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;EACA,0BAAA;AAqHJ;AAnHE;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,uBAAA;AAqHJ;AAnHE;EACE,wBAAA;AAqHJ;;AAlHA;;EAEE,iCAAA;AAqHF;;AAlHA;EACE,yBAAA;AAqHF;;AAnHA;EACE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,QAAA;EACA,yBAAA;EAEA,kCAAA;EACA,0BAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AAsHF;;AApHA;EACE;IACE,uBAAA;EAuHF;EArHA;IACE,yBAAA;EAuHF;AACF;AArHA;EACE,gCAAA;EACA,cAAA;EACA,MAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;AAuHF;;AApHA;EACE,cAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,0BAAA;EACA,wBAAA;EACA,yBAAA;UAAA,wBAAA;EAKA,gBAAA;EACA,gCAAA;AAmHF;AAxHE;EACE,sBAAA;UAAA,qBAAA;EACA,2BAAA;UAAA,0BAAA;AA0HJ;;AArHA;EACE,gBAAA;EACA,gCAAA;AAwHF;;AA5GA;EACE,8BAAA;AA+GF;;AA7GA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAgHF;;AA9GA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAiHF;;AA/GA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAkHF;;AAhHA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;EACA,eAAA;AAmHF;AAlHE;EACE,WAAA;AAoHJ;;AAjHA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,QAAA;EACA,sBAAA;EAAA,yBAAA;EACA,wBAAA;UAAA,uBAAA;AAoHF;;AAlHA;EACE,2CAAA;AAqHF;;AAnHA;EACE,uCAAA;AAsHF;;AApHA;EACE,sCAAA;AAuHF;;AArHA;EACE,6CAAA;EACA,sDAAA;AAwHF;;AAtHA;EACE,+BAAA;AAyHF;;AAvHA;EACE,eAAA;AA0HF;;AAvHA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;AA0HF;;AAvHE;EACE,UAAA;EACA,uCAAA;AA0HJ;AAxHE;EACE,uCAAA;AA0HJ;;AAvHA;EACE,uBAAA;AA0HF;;AAxHA;EACE,2BAAA;AA2HF;;AAzHA;EACE,2BAAA;AA4HF;;AA1HA;EACE,kBAAA;AA6HF","sourcesContent":["//DIRECTIONS\n$ltr: 'body[dir=' ltr ']';\n$rtl: 'body[dir=' rtl ']';\n\n// FONTS\n@font-face {\n  font-family: LatoRegular;\n  src: url(../fonts/Lato-Regular.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: LatoBold;\n  src: url(../fonts/Lato-Bold.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoRegular;\n  src: url(../fonts/Cairo-Regular.ttf);\n  font-display: swap;\n}\n@font-face {\n  font-family: CairoBold;\n  src: url(../fonts/Cairo-Bold.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirp;\n  src: url(../fonts/chirp.ttf);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpBold;\n  src: url(../fonts/chirp-bold-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpHeavy;\n  src: url(../fonts/chirp-heavy-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpMedium;\n  src: url(../fonts/chirp-medium-web.woff);\n  font-display: swap;\n}\n\n@font-face {\n  font-family: chirpRegular;\n  src: url(../fonts/chirp-regular-web.woff);\n  font-display: swap;\n}\n\n$latoRegular: 'LatoRegular', 'CairoRegular', sans-serif;\n$latoBold: 'LatoBold', 'CairoBold', sans-serif;\n$CairoRegular: 'CairoRegular', 'LatoRegular', sans-serif;\n$CairoBold: 'CairoBold', 'LatoBold', sans-serif;\n\n// COMMON STYLES\n%tablesTitle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n%pageTitle {\n  #{$ltr} & {\n    font-family: $latoBold !important;\n  }\n  #{$rtl} & {\n    font-family: $CairoBold !important;\n  }\n  font-size: 18px;\n  text-transform: uppercase;\n  position: relative;\n  margin-bottom: 40px;\n\n  &::before {\n    content: '';\n    position: absolute;\n    start: 0;\n    bottom: -10px;\n    border: 2px solid var(--secondaryColor);\n    width: 42px;\n    background-color: var(--secondaryColor);\n  }\n}\n\n%centeredHrVr {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  -webkit-transform: translate(-50%, -50%);\n  -moz-transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  -o-transform: translate(-50%, -50%);\n}\n\n// MIXINS\n@mixin fontSize($size) {\n  @if ($size == 10) {\n    font-size: 10px !important;\n  } @else if ($size == 12) {\n    font-size: 12px !important;\n  } @else if($size == 14) {\n    font-size: 14px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 16) {\n    font-size: 16px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 18) {\n    font-size: 18px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if($size == 24) {\n    font-size: 24px !important;\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n  } @else if ($size == 48) {\n    #{$ltr} & {\n      font-family: $latoBold !important;\n    }\n    #{$rtl} & {\n      font-family: $CairoBold !important;\n    }\n    font-size: 48px !important;\n    color: #606060;\n  }\n}\n\n// Responsive Mixin\n@mixin Sm {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin Md {\n  @media (min-width: 992px) and (max-width: 1200px) {\n    @content;\n  }\n}\n\n.scroll {\n  &::-webkit-scrollbar {\n    height: 8px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: var(--bodyColor);\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--mainColor);\n  }\n}\n","@import './app/assets/scss/vars';\r\n\r\n* {\r\n  padding: 0;\r\n  margin: 0;\r\n  box-sizing: border-box;\r\n  &::-webkit-scrollbar {\r\n    display: none;\r\n  }\r\n}\r\nbody {\r\n  &[dir='ltr'] {\r\n    font-family: $latoRegular;\r\n  }\r\n  &[dir='rtl'] {\r\n    font-family: $CairoRegular;\r\n  }\r\n  &::-webkit-scrollbar {\r\n    display: none;\r\n  }\r\n  &\r\n    > iframe[style='position: fixed; inset: 0px; width: 100vw; height: 100vh; border: none; z-index: 2147483647;'] {\r\n    display: none;\r\n  }\r\n  font-weight: 400;\r\n  background-color: var(--bodyColor);\r\n  color: var(--mainColor);\r\n  overflow-x: hidden;\r\n  font-size: 14px;\r\n}\r\na,\r\nlink,\r\na:link,\r\na:active {\r\n  color: var(--mainColor);\r\n  text-decoration: none;\r\n}\r\n.active {\r\n  color: var(--secondaryColor);\r\n}\r\n.actionsCell {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 100%;\r\n  // margin-block-start: -0.2em;\r\n  // margin-block-start: 0;\r\n}\r\n// page title\r\nh2 {\r\n  @extend %pageTitle;\r\n}\r\n\r\n// sidebar items, hashtag title\r\nh3 {\r\n  @include fontSize(14);\r\n  text-transform: uppercase;\r\n}\r\n\r\n// popper title\r\nh4 {\r\n  @include fontSize(12);\r\n  text-transform: uppercase;\r\n  margin-bottom: 10px;\r\n}\r\n\r\np {\r\n  @include fontSize(10);\r\n}\r\n\r\n*::-webkit-scrollbar {\r\n  width: 8px;\r\n}\r\n\r\n*::-webkit-scrollbar-track {\r\n  box-shadow: inset 0 0 6px grey;\r\n}\r\n\r\n*::-webkit-scrollbar-thumb {\r\n  background-color: var(--mainColor);\r\n  outline: 1px solid slategrey;\r\n}\r\n\r\n.MuiButton-root {\r\n  color: var(--mainColor) !important;\r\n  border: 1px solid var(--borderColor) !important;\r\n  width: 102px;\r\n  height: 30px;\r\n  text-transform: capitalize !important;\r\n  border-radius: 0 !important;\r\n  &[dir='ltr'] {\r\n    font-family: $latoRegular !important;\r\n  }\r\n  &[dir='rtl'] {\r\n    font-family: $CairoRegular !important;\r\n  }\r\n}\r\n.MuiFormControl-root {\r\n  width: 100%;\r\n}\r\n.apexcharts-tooltip.apexcharts-theme-light {\r\n  background-color: var(--bgColor) !important;\r\n  border: 1px solid var(--borderColor) !important;\r\n}\r\n.main-btn {\r\n  background-color: var(--secondaryColor) !important;\r\n  color: var(--bgColor) !important;\r\n  border: 0 !important;\r\n}\r\nbutton {\r\n  @include fontSize(10);\r\n  font-family: $latoRegular;\r\n}\r\n.deleteHolder {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  p {\r\n    @include fontSize(12);\r\n    font-weight: bold;\r\n  }\r\n}\r\n.text-btn-holder {\r\n  display: flex;\r\n}\r\n\r\n.text-btn {\r\n  background-color: transparent;\r\n  border: none;\r\n  align-items: center;\r\n  // width: 100%;\r\n  text-align: right;\r\n  @include fontSize(12);\r\n  color: var(--secondaryColor);\r\n  text-transform: capitalize;\r\n  cursor: pointer;\r\n  #{$ltr} & {\r\n    font-family: $latoRegular !important;\r\n  }\r\n  #{$rtl} & {\r\n    font-family: $CairoRegular !important;\r\n  }\r\n}\r\n.unstyled-button {\r\n  background-color: 'transparent';\r\n  padding: none;\r\n  border: none;\r\n  height: 0;\r\n  cursor: pointer;\r\n  &[data-error='true'] path:first-of-type {\r\n    stroke: var(--errorColor);\r\n  }\r\n  &[data-error='true'] path:last-of-type {\r\n    fill: var(--errorColor);\r\n  }\r\n  &:disabled,\r\n  & [disabled] {\r\n    cursor: unset;\r\n  }\r\n}\r\n.phoneInputStyle {\r\n  display: flex;\r\n  margin-top: 10px;\r\n  align-items: flex-end;\r\n  div {\r\n    width: 100%;\r\n  }\r\n  button {\r\n    margin-top: 1em;\r\n  }\r\n}\r\n.fullWidthWithBtn {\r\n  div {\r\n    width: 95%;\r\n  }\r\n}\r\n.leaflet-container {\r\n  height: 763px;\r\n  width: 100%;\r\n  z-index: 500;\r\n}\r\n.leaflet-control-container .leaflet-left,\r\nleaflet-control-container .leaflet-top {\r\n  right: 1rem;\r\n  bottom: 1rem;\r\n}\r\n.leaflet-touch .leaflet-bar a {\r\n  line-height: 19px !important;\r\n  width: 23px !important;\r\n  height: 23px !important;\r\n  font-size: 19px;\r\n  font-weight: 100;\r\n  color: #555;\r\n}\r\n.leaflet-control-zoom {\r\n  position: absolute !important;\r\n  right: 0;\r\n  bottom: 0;\r\n}\r\n.leaflet-control-zoom-in {\r\n  margin-bottom: 1rem;\r\n}\r\n.leaflet-control-zoom-out {\r\n  margin-bottom: 1rem;\r\n}\r\n.leaflet-control-zoom {\r\n  border: none !important;\r\n}\r\n.leaflet-control-attribution {\r\n  display: none;\r\n}\r\n.leaflet-control-zoom a {\r\n  border: 1px solid !important;\r\n}\r\n\r\n.actionsCell:hover .actions {\r\n  opacity: 1;\r\n}\r\n\r\n.actions {\r\n  opacity: 0;\r\n  z-index: 1;\r\n\r\n  @include Sm {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\ndiv[class*='PrivateSwitchBase'] {\r\n  @include Sm {\r\n    padding: 0;\r\n  }\r\n}\r\n\r\n.mr-5 {\r\n  margin-inline-end: 5px;\r\n}\r\n.ml-5 {\r\n  margin-inline-start: 5px;\r\n}\r\n.mb-20 {\r\n  margin-bottom: 20px;\r\n}\r\n.mb-10 {\r\n  margin-bottom: 10px;\r\n}\r\n.mb-15 {\r\n  margin-bottom: 15px;\r\n}\r\n.mr-20 {\r\n  margin-inline-end: 20px !important;\r\n}\r\n.mr-5 {\r\n  margin-inline-end: 5px !important;\r\n}\r\n\r\n.mb-30 {\r\n  margin-bottom: 30px;\r\n}\r\n.mt-10 {\r\n  margin-top: 10px;\r\n}\r\n.mt-16 {\r\n  margin-top: 16px;\r\n}\r\n.mt-30 {\r\n  margin-top: 30px;\r\n}\r\n.mt-5 {\r\n  margin-top: 5px;\r\n}\r\n.mt-20- {\r\n  margin-top: -20px;\r\n}\r\n.m-auto {\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n.d-block {\r\n  display: block;\r\n}\r\n.mt-5-ar {\r\n  #{$rtl} & {\r\n    margin-top: 5px;\r\n  }\r\n}\r\n.flex-alignCenter {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n.flex-center {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.flex-sb {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n}\r\n.flex-wrap {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  flex-wrap: wrap;\r\n}\r\n.hide-last {\r\n  :last-child {\r\n    span {\r\n      display: none;\r\n    }\r\n  }\r\n}\r\n\r\n.cursor-pointer {\r\n  cursor: pointer;\r\n  &-decoration {\r\n    text-decoration-line: underline;\r\n  }\r\n}\r\n.p-20 {\r\n  padding: 20px;\r\n}\r\n.p-line-20 {\r\n  padding-inline: 20px !important;\r\n}\r\n.p-line-10 {\r\n  padding-inline: 10px !important;\r\n}\r\n.p-30 {\r\n  padding: 30px;\r\n}\r\n.p-lin-s {\r\n  padding-inline-start: 20px;\r\n}\r\n.pb-20 {\r\n  padding-bottom: 20px;\r\n}\r\n\r\n.b-1 {\r\n  border: 1px solid var(--borderColor);\r\n}\r\n.bt-1 {\r\n  border-top: 1px solid var(--borderColor);\r\n}\r\n.bb-1 {\r\n  border-bottom: 1px solid var(--borderColor);\r\n}\r\n.position-relative {\r\n  position: relative;\r\n}\r\n.default-height {\r\n  min-height: 272px;\r\n}\r\n\r\n.PageTopBar {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  width: 100%;\r\n\r\n  button {\r\n    border: none;\r\n    background: transparent;\r\n    vertical-align: middle;\r\n    cursor: pointer;\r\n  }\r\n  .Controls {\r\n    position: relative;\r\n    z-index: 99;\r\n    height: 27px;\r\n    display: flex;\r\n    align-items: center;\r\n    @include Sm {\r\n      display: flex;\r\n      align-items: center;\r\n    }\r\n  }\r\n}\r\n.Controls {\r\n  height: 27px;\r\n  display: flex;\r\n  align-items: center;\r\n  @include Sm {\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n}\r\n.TopBar {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  width: 100%;\r\n  .Controls {\r\n    // gap: 20px;\r\n    display: flex;\r\n    align-items: center;\r\n    align-self: baseline;\r\n  }\r\n  .Controls > *:not(:last-child) {\r\n    //margin-inline-end: 40px;\r\n    position: relative;\r\n    padding: 0;\r\n    @include Sm {\r\n      margin-inline-end: 20px;\r\n    }\r\n    &::after {\r\n      content: '';\r\n      position: absolute;\r\n      #{$ltr} & {\r\n        right: -20px;\r\n      }\r\n      #{$rtl} & {\r\n        left: -20px;\r\n      }\r\n      width: 2px;\r\n      height: 20px;\r\n      background-color: var(--borderColor);\r\n      @include Sm {\r\n        #{$ltr} & {\r\n          right: -10px;\r\n        }\r\n        #{$rtl} & {\r\n          left: -10px;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n// div[title] {\r\n//   opacity: 0;\r\n// }\r\n// div[title]:hover:after {\r\n//   content: attr(title);\r\n//   background: var(--bodyColor);\r\n//   position: absolute;\r\n//   left: 5%;\r\n//   top: 10%;\r\n//   color: var(--mainColor);\r\n//   padding: 5px;\r\n//   border: 1px solid var(--borderColor);\r\n// }\r\n.gap-5 {\r\n  *:not(:last-child) {\r\n    margin-bottom: 5px;\r\n  }\r\n}\r\n.Controls > * {\r\n  padding: 0 !important;\r\n  color: var(--borderColor);\r\n  &:not(:first-of-type) {\r\n    margin-inline-start: 20px;\r\n  }\r\n  &:not(:last-of-type) {\r\n    position: relative;\r\n    margin-inline-end: 10px;\r\n    &::after {\r\n      content: '';\r\n      position: absolute;\r\n      #{$ltr} & {\r\n        right: -20px;\r\n      }\r\n      #{$rtl} & {\r\n        left: -20px;\r\n      }\r\n      width: 2px;\r\n      height: 15px;\r\n      background-color: var(--borderColor);\r\n    }\r\n  }\r\n}\r\n.MuiSvgIcon-root {\r\n  margin: 0;\r\n}\r\ninput,\r\ntextarea {\r\n  #{$ltr} & {\r\n    font-family: $latoRegular;\r\n  }\r\n  #{$rtl} & {\r\n    font-family: $CairoRegular;\r\n  }\r\n}\r\ninput::placeholder,\r\ntextarea::placeholder,\r\n.select-input__placeholder {\r\n  color: var(--mainColor) !important;\r\n  text-transform: capitalize;\r\n}\r\n.MuiPaper-elevation1 {\r\n  box-shadow: none !important;\r\n}\r\n.SaveCancel {\r\n  display: flex;\r\n  justify-content: space-around;\r\n  button {\r\n    cursor: pointer;\r\n    display: inline-block;\r\n    min-width: 102px;\r\n    font-size: 10px;\r\n    color: var(--mainColor);\r\n    border: 1px solid #d7d7d7;\r\n    padding: 9px 8px;\r\n    -webkit-transition: 0.3s ease-out;\r\n    transition: 0.3s ease-out;\r\n    text-align: center;\r\n    text-transform: uppercase;\r\n    &:hover {\r\n      color: var(--bgColor);\r\n      border-color: var(--secondaryColor);\r\n      background-color: var(--secondaryColor);\r\n    }\r\n  }\r\n}\r\n.InputHolder {\r\n  padding: 20px;\r\n  min-width: 100%;\r\n  background-color: var(--bgColor);\r\n}\r\n\r\n// react-toastify\r\n.Toastify__toast-container {\r\n  width: 365px;\r\n  text-align: center;\r\n  text-transform: capitalize;\r\n  padding: 0;\r\n  @include fontSize(12);\r\n  #{$ltr} & {\r\n    font-family: $latoRegular !important;\r\n  }\r\n  #{$rtl} & {\r\n    font-family: $CairoRegular !important;\r\n  }\r\n}\r\n.Toastify__toast {\r\n  border-radius: 0;\r\n  height: 30px;\r\n  min-height: auto;\r\n  margin-bottom: 0;\r\n  padding: 0;\r\n}\r\n.Toastify__toast-body {\r\n  padding: 0 8px;\r\n}\r\n\r\n.Toastify__toast--success {\r\n  background-color: #ecedd8;\r\n  border: 1px solid #9ea641;\r\n  color: black;\r\n}\r\n\r\n.Toastify__toast--error {\r\n  background-color: rgb(255, 28, 0, 0.5);\r\n  border: 1px solid #ff1c00;\r\n  color: black;\r\n}\r\n.errorColor {\r\n  color: #ff1c00;\r\n}\r\n.Toastify__toast-container--top-center {\r\n  top: 50px;\r\n}\r\n.MuiPickersDay-day.MuiPickersDay-dayDisabled {\r\n  pointer-events: auto !important;\r\n  cursor: not-allowed !important;\r\n  background-color: var(--disabledDatePicker) !important;\r\n}\r\n// .MuiRadio-colorSecondary.Mui-checked {\r\n//   color: var(--secondaryColor) !important;\r\n// }\r\n.MuiMenuItem-root,\r\n.MuiSelect-select.MuiSelect-select {\r\n  #{$ltr} & {\r\n    font-family: $latoRegular !important;\r\n  }\r\n  #{$rtl} & {\r\n    font-family: $CairoRegular !important;\r\n  }\r\n}\r\n.apexcharts-legend-text {\r\n  word-break: break-all;\r\n  //text-align: justify;\r\n  text-align: center;\r\n  align-items: center;\r\n  padding-left: 0px !important;\r\n  margin-left: 0px !important;\r\n}\r\n.apexcharts-text {\r\n  #{$ltr} & {\r\n    font-family: $latoRegular !important;\r\n  }\r\n  #{$rtl} & {\r\n    font-family: $CairoRegular !important;\r\n  }\r\n  tspan {\r\n    fill: var(--mainColor);\r\n    @include fontSize(10);\r\n  }\r\n}\r\n.apexcharts-xaxis-texts-g {\r\n  #{$rtl} & {\r\n    transform: translateY(10px);\r\n  }\r\n}\r\n\r\n.MuiTypography-caption,\r\n.MuiPaginationItem-root {\r\n  color: var(--mainColor) !important;\r\n  #{$ltr} & {\r\n    font-family: $latoRegular !important;\r\n  }\r\n  #{$rtl} & {\r\n    font-family: $CairoRegular !important;\r\n  }\r\n}\r\n.MuiTypography-subtitle1 {\r\n  @include fontSize(14);\r\n}\r\n.apexcharts-data-labels {\r\n  text {\r\n    #{$ltr} & {\r\n      font-family: $latoRegular !important;\r\n    }\r\n    #{$rtl} & {\r\n      font-family: $CairoRegular !important;\r\n    }\r\n    fill: var(--mainColor);\r\n    font-weight: 500;\r\n    filter: none;\r\n    line-height: 29;\r\n  }\r\n}\r\n\r\n/* Chrome, Safari, Edge, Opera */\r\ninput::-webkit-outer-spin-button,\r\ninput::-webkit-inner-spin-button {\r\n  -webkit-appearance: none;\r\n  margin: 0;\r\n}\r\n\r\n/* Firefox */\r\ninput[type='number'] {\r\n  -moz-appearance: textfield;\r\n}\r\n.tableRow {\r\n  line-height: 14px;\r\n}\r\n.secondaryTableRow {\r\n  a {\r\n    width: max-content !important;\r\n  }\r\n}\r\n.default__link {\r\n  padding: 0 4px;\r\n  text-decoration: underline;\r\n  color: var(--secondaryColor);\r\n  &-gray {\r\n    color: var(--mainColor);\r\n    text-decoration: underline !important;\r\n  }\r\n  a {\r\n    color: var(--secondaryColor);\r\n    text-decoration: underline !important;\r\n  }\r\n}\r\n\r\n.button-link {\r\n  font-family: inherit;\r\n  background-color: unset;\r\n  border: unset;\r\n  transition: 0.2s;\r\n  font-size: inherit;\r\n  color: var(--mainColor);\r\n  &:hover {\r\n    color: var(--secondaryColor);\r\n    text-decoration: underline !important;\r\n  }\r\n}\r\n.change_profile_img {\r\n  margin: 30px 0;\r\n  width: 102px;\r\n  height: 102px;\r\n  border-radius: 50%;\r\n  margin-bottom: 30px;\r\n  margin-inline-end: auto;\r\n  position: relative;\r\n  cursor: pointer;\r\n  svg {\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n  .img_holder {\r\n    width: 100%;\r\n    height: 100%;\r\n    border-radius: 50%;\r\n    overflow: hidden;\r\n    border: 1px solid var(--borderColor);\r\n\r\n    img {\r\n      width: 100%;\r\n      height: 100%;\r\n      object-fit: cover;\r\n    }\r\n  }\r\n  label {\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100%;\r\n    top: 0;\r\n    left: 0;\r\n    border-radius: 100%;\r\n    transition: 0.3s;\r\n    cursor: pointer;\r\n\r\n    input[type='file'] {\r\n      display: none;\r\n    }\r\n  }\r\n}\r\n\r\n.dimmedHolder {\r\n  position: relative;\r\n  .dimmed {\r\n    position: absolute;\r\n    left: 0;\r\n    top: 26px;\r\n    width: 100%;\r\n    height: 54%;\r\n    z-index: 2;\r\n    background-color: var(--borderColor);\r\n    opacity: 0.7;\r\n  }\r\n  .horizDimmed {\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    z-index: 2;\r\n    background-color: var(--borderColor);\r\n    opacity: 0.7;\r\n  }\r\n}\r\n.MuiDialog-container {\r\n  background-color: var(--errorBoundBgColor);\r\n}\r\n.loader-holder {\r\n  height: 500px;\r\n  width: 100%;\r\n  position: relative;\r\n}\r\n.source-input {\r\n  display: flex;\r\n  align-items: flex-end;\r\n  button {\r\n    background-color: transparent;\r\n    border: none;\r\n    padding: 0px 10px 5px;\r\n    cursor: pointer;\r\n  }\r\n  & > div {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.source-link {\r\n  text-overflow: ellipsis;\r\n  overflow: hidden;\r\n  white-space: nowrap;\r\n  display: block;\r\n  margin-top: 10px;\r\n}\r\n.truncate-text {\r\n  width: 100%;\r\n  text-overflow: ellipsis;\r\n  overflow: hidden;\r\n  font-family: inherit !important;\r\n}\r\n\r\n.trim-text {\r\n  word-wrap: break-word;\r\n  white-space: nowrap;\r\n  width: 100%;\r\n  overflow: hidden;\r\n  display: block;\r\n  text-overflow: ellipsis;\r\n}\r\n.MuiCheckbox-colorSecondary.Mui-checked {\r\n  color: var(--mainColor) !important;\r\n}\r\n.InovuaReactDataGrid__row-cell-wrap:focus {\r\n  outline: 0;\r\n}\r\n.InovuaReactDataGrid__cell--show-border-bottom,\r\n.InovuaReactDataGrid--theme-default-light .InovuaReactDataGrid__header {\r\n  border-bottom: 1px solid var(--borderColor) !important;\r\n}\r\n.flex-center-between {\r\n  display: flex;\r\n  justify-items: center;\r\n  justify-content: space-between;\r\n}\r\n.pagination {\r\n  padding-top: 30px;\r\n  direction: initial;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  /* height: 130px; */\r\n}\r\n// TO SOLVE TOP-POSTS ACTION CELLS HOVER: the title was getting over the components\r\n.MuiTooltip-popper {\r\n  z-index: 1000 !important;\r\n}\r\n.TopBar {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n.loader-parent {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 85vh;\r\n}\r\n\r\n.apexcharts-tooltip-marker {\r\n  margin-inline-end: 10px;\r\n}\r\n\r\n#videos-compareVideos-CompareInputsRow\r\n  + div\r\n  .apexcharts-yaxis\r\n  .apexcharts-yaxis-texts-g {\r\n  transform: translateY(-15px);\r\n}\r\n\r\n#mainFilter .select-input__input-container {\r\n  padding: 1px 0px !important;\r\n}\r\n\r\n.apexcharts-tooltip {\r\n  z-index: 9999 !important;\r\n}\r\n\r\n* {\r\n  .small_tooltip {\r\n    .apexcharts-tooltip {\r\n      width: 150px !important;\r\n      height: max-content;\r\n      .trending_topics {\r\n        margin: 0 10px;\r\n        :first-child {\r\n          margin-bottom: 5px;\r\n        }\r\n        * {\r\n          font-size: 10px;\r\n          font-family: 'LatoRegular';\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// custom class\r\n.w- {\r\n  &10 {\r\n    width: 10%;\r\n  }\r\n  &20 {\r\n    width: 20%;\r\n  }\r\n  &30 {\r\n    width: 30%;\r\n  }\r\n  &40 {\r\n    width: 40%;\r\n  }\r\n  &50 {\r\n    width: 50%;\r\n  }\r\n  &60 {\r\n    width: 60%;\r\n  }\r\n  &70 {\r\n    width: 70%;\r\n  }\r\n  &80 {\r\n    width: 80%;\r\n  }\r\n  &90 {\r\n    width: 90%;\r\n  }\r\n  &full {\r\n    width: 100%;\r\n  }\r\n}\r\n.d- {\r\n  &flex {\r\n    display: flex;\r\n    &-between {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: space-between;\r\n    }\r\n    &-items {\r\n      &-center {\r\n        display: flex;\r\n        align-items: center;\r\n      }\r\n    }\r\n    &-content {\r\n      &-center {\r\n        display: flex;\r\n        justify-content: center;\r\n      }\r\n    }\r\n    &-center {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n    }\r\n  }\r\n}\r\n\r\n.pt- {\r\n  &7 {\r\n    padding-top: 7px;\r\n  }\r\n  &10 {\r\n    padding-top: 20px;\r\n  }\r\n  &14 {\r\n    padding-top: 14px;\r\n  }\r\n}\r\n.reactEasyCrop_Container {\r\n  z-index: 111111;\r\n}\r\n.server-error {\r\n  position: relative;\r\n  &::before {\r\n    content: attr(data-error-massage);\r\n    display: block;\r\n    position: absolute;\r\n    top: 0;\r\n    left: 50%;\r\n    transform: translate(-50%, 40px);\r\n    z-index: 1248;\r\n    color: var(--mainColor);\r\n    font-weight: bold;\r\n    font-size: 24px;\r\n    text-align: center;\r\n    text-transform: capitalize;\r\n    background: var(--errorBoundBgColor);\r\n    width: calc(100% - 40px);\r\n    height: calc(100% - 40px);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    // padding: 25px;\r\n  }\r\n}\r\ntextarea,\r\ninput,\r\npre,\r\n.css-qc6sy-singleValue,\r\n.css-12jo7m5,\r\n.MuiTableCell-body,\r\n.MuiTableCell-head,\r\n.apexcharts-legend-text,\r\n.MuiPaper-root,\r\n.css-26l3qy-menu {\r\n  color: var(--mainColor) !important;\r\n  background-color: var(--bgColor);\r\n}\r\n.MuiMenu-paper {\r\n  background-color: var(--bgColor) !important;\r\n  border: 1px solid var(--borderColor) !important;\r\n}\r\n.notifications {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n  text-transform: uppercase;\r\n\r\n  .notificatiosUserName {\r\n    display: flex;\r\n    align-items: flex-start;\r\n    gap: 20px;\r\n    font-weight: normal;\r\n    font-size: 12px;\r\n    text-transform: capitalize;\r\n  }\r\n  .notifications-flex {\r\n    display: flex;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n  }\r\n  .notifications-b > b {\r\n    font-family: 'CairoBold';\r\n  }\r\n}\r\n.apexcharts-text,\r\n.MuiSvgIcon-root {\r\n  fill: var(--mainColor) !important;\r\n}\r\n\r\n.link-without-hover:hover {\r\n  color: unset !important;\r\n}\r\n.custLoader {\r\n  position: absolute;\r\n  z-index: 11351;\r\n  left: 50%;\r\n  top: 45%;\r\n  border: 5px solid #f3f3f3;\r\n  -webkit-animation: spin 1s linear infinite;\r\n  animation: spin 1s linear infinite;\r\n  border-top: 5px solid #555;\r\n  border-radius: 50%;\r\n  width: 50px;\r\n  height: 50px;\r\n  overflow: hidden;\r\n}\r\n@keyframes spin {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n.custLoaderBg {\r\n  background-color: var(--bgColor);\r\n  z-index: 11350;\r\n  top: 0;\r\n  position: absolute;\r\n  width: 100vw;\r\n  height: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\n.custLoaderText {\r\n  z-index: 11351;\r\n  position: absolute;\r\n  width: 100vw;\r\n  text-align: center;\r\n  top: 55%;\r\n  font-size: 20px !important;\r\n  font-family: 'CairoBold';\r\n  padding-inline-end: 40px;\r\n  #{$ltr} & {\r\n    padding-inline-end: 0;\r\n    padding-inline-start: 40px;\r\n  }\r\n  overflow: hidden;\r\n  background-color: var(--bgColor);\r\n}\r\n.hide {\r\n  overflow: hidden;\r\n  background-color: var(--bgColor);\r\n}\r\n.pdf_container {\r\n  // display: flex !important;\r\n  // flex-wrap: wrap !important;\r\n  // box-sizing: border-box;\r\n  // gap: 40px;\r\n  // justify-content: space-between;\r\n  // padding: 30px 60px;\r\n  // background-color: #fafafa;\r\n  // margin-inline: 30px;\r\n}\r\n.MuiDialog-paper {\r\n  overflow-y: visible !important;\r\n}\r\n.flex-center-gap-10 {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n.flex-center-gap-5 {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n}\r\n.flex-center-gap-30 {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 30px;\r\n}\r\n.flex-icons {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  flex-wrap: wrap;\r\n  column-gap: 7px;\r\n  svg {\r\n    width: 18px;\r\n  }\r\n}\r\n.flex-column-reverse {\r\n  display: flex;\r\n  justify-content: center;\r\n  flex-direction: column-reverse;\r\n  gap: 5px;\r\n  width: unset !important;\r\n  margin-inline-end: 20px;\r\n}\r\n.tweetSubTitleColor {\r\n  color: var(--tweetSubTitleColor) !important;\r\n}\r\n.instagramColor {\r\n  color: var(--instagramColor) !important;\r\n}\r\n.labelDisabled {\r\n  color: var(--disabledLabel) !important;\r\n}\r\n.apexcharts-tooltip-title {\r\n  background-color: var(--bodyColor) !important;\r\n  border-bottom: 1px solid var(--borderColor) !important;\r\n}\r\nbody.no-Events {\r\n  pointer-events: none !important;\r\n}\r\n.descriptionContent {\r\n  max-width: 100%;\r\n}\r\n\r\n.MuiSwitch-thumb {\r\n  position: absolute;\r\n  top: 10px;\r\n  left: 0;\r\n}\r\n.Mui-checked {\r\n  .MuiSwitch-thumb {\r\n    left: 10px;\r\n    background-color: var(--secondaryColor);\r\n  }\r\n  .MuiSwitch-track {\r\n    background-color: var(--secondaryColor);\r\n  }\r\n}\r\n.MuiIconButton-root {\r\n  padding: 5px !important;\r\n}\r\n.Active {\r\n  color: var(--positiveColor);\r\n}\r\n.Suspended {\r\n  color: var(--negativeColor);\r\n}\r\n.text-center {\r\n  text-align: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
